import { put } from "redux-saga/effects";

import { apiFetch } from "common/utilities";
import { logger } from "common/utilities/logger";
import { unfollowCollectionFailure, unfollowCollectionSuccess } from "domains/collection/actions";
import type { UnfollowCollectionAction } from "domains/collection/actionTypes";

export function* unfollowCollectionSaga({ payload }: UnfollowCollectionAction) {
  try {
    yield apiFetch(`collection/${payload.id}/follow`, { method: "DELETE" });
    yield put(unfollowCollectionSuccess(payload.id));
  } catch (error) {
    logger.error(`[unfollowCollectionSaga] Failed to unfollow collection with ID '${payload.id}'`, error);
    yield put(unfollowCollectionFailure(payload.id));
  }
}
